/**
 * Channels List - Display EAS channels
 */

interface ChannelsListProps {
  channels: any[]
  isLoading: boolean
}

export function ChannelsList({ channels, isLoading }: ChannelsListProps) {
  if (isLoading) {
    return <div className="text-muted-foreground">Loading channels...</div>
  }

  if (channels.length === 0) {
    return <div className="text-muted-foreground">No channels found</div>
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {channels.map((channel) => (
        <div
          key={channel.id}
          className="bg-background border border-border rounded-lg p-4 hover:shadow-md transition-shadow"
        >
          <h3 className="text-lg font-semibold text-foreground mb-2">{channel.name}</h3>

          <div className="space-y-2 text-sm">
            <div>
              <span className="text-muted-foreground">Created:</span>
              <span className="ml-2 text-foreground">{new Date(channel.createdAt).toLocaleDateString()}</span>
            </div>

            <div>
              <span className="text-muted-foreground">Updated:</span>
              <span className="ml-2 text-foreground">{new Date(channel.updatedAt).toLocaleDateString()}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
